import {
  Box,
  Card,
  HeadingText,
  ParagraphText,
  StackLayout,
  queryHelpers,
  useMediaQuery,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { PageHeaderBackground } from '@leagueplatform/web-common-components';

export const AboutPage = () => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(queryHelpers.down('tablet'));

  const title = formatMessage({ id: 'STR_ABOUT_TRILLIUM_CONNECT' });
  useDocumentTitle(title);

  return (
    <>
      <PageHeaderBackground
        alignItems="center"
        width="100%"
        maxWidth="950px"
        marginX="auto"
      >
        <HeadingText
          level="1"
          size={{ '@initial': 'xxl', '@mobile': 'xl' }}
          css={{ paddingInlineStart: isMobile ? '$oneAndHalf' : '$none' }}
        >
          {title}
        </HeadingText>
      </PageHeaderBackground>

      <Box
        css={{
          padding: isMobile ? '$two $oneAndHalf' : '$two $none',
          maxWidth: '950px',
          marginX: 'auto',
        }}
      >
        <Card.Flat
          css={{
            padding: isMobile ? '$two $oneAndHalf' : '$two',
            display: 'flex',
            backgroundColor: '$surfaceCardPrimary',
            border: '1px solid $onSurfaceBorderCard',
          }}
        >
          <StackLayout
            orientation={isMobile ? 'vertical' : 'horizontal'}
            css={{
              gap: '$twoAndHalf',
              alignItems: isMobile ? 'center' : 'flex-start',
            }}
          >
            {/* TODO: replace with actual logo image */}
            <Box
              data-testid="about-logo-placeholder"
              css={{
                width: '120px',
                height: '120px',
                minWidth: '120px',
                borderRadius: '$medium',
                backgroundColor: '$interactiveActionDisabled',
              }}
            />

            {/* TODO: replace with actual app description */}
            <ParagraphText>
              {formatMessage({ id: 'STR_FOOTER_DISCLAIMER' })}
            </ParagraphText>
          </StackLayout>
        </Card.Flat>
      </Box>
    </>
  );
};
